<template>
  <Table
    @dragged="displaceCategory"
    ref="table"
    draggable
    :headers="headers"
    :loading="loading"
    :list="menu_categories"
    :search="el => {
      return el.id == search || el.name.toLowerCase().includes((search || '').toLowerCase()) || el.alt_name.toLowerCase().includes((search || '').toLowerCase())
    }"
  >
    <TableHeader :top="126">
      <template #ontop="{headers}">
        <tr>
          <th :colspan="headers.length" style="font-weight: normal"> 
            <v-text-field :label="$t('Поиск товаров')" class="d-inline" v-model="search" prepend-inner-icon="mdi-magnify" clearable dense outlined filled hide-details></v-text-field>
          </th>
        </tr>
      </template>
      <template #header:actions>
        <div class="d-flex justify-end">
          <v-btn :title="$t('Раскрыть все')" @click="$refs.table.expandAll()" icon small><v-icon>mdi-folder-arrow-down-outline</v-icon></v-btn>
          <v-btn :title="$t('Свернуть все')" @click="$refs.table.foldAll()" icon small ><v-icon>mdi-folder-arrow-up-outline</v-icon></v-btn>
        </div>
      </template>
    </TableHeader>

    <TableBody v-for="category in menu_merged_items" :key="category.id" :items="category.items" @dragged="displaceMenuitem">
      
      <template #ontop="{ headers, expand, fold, expanded, filtered }">
        <tr style="background: var(--v-primary-darken1) !important; color: var(--v-secondary-lighten5); position: sticky; top: 218px; border-radius: .3em">
          <td :colspan="headers.length" style="border-radius: .3em">
            <div class="d-flex align-center">
              <v-btn color="secondary lighten-5" :title="$t('Свернуть')" v-if="expanded" icon @click="fold"><v-icon>mdi-chevron-down</v-icon></v-btn>
              <v-btn :class="{'hover-slave': !expanded}" color="secondary lighten-5" :title="$t('Раскрыть')" v-else icon @click="expand"><v-icon>mdi-chevron-right</v-icon></v-btn>
              <span style="display: inline">
                <T>Категория</T>: {{category.name}}
              </span>
              <v-spacer></v-spacer>
              <v-btn :class="{'hover-slave': !expanded}" v-if="!filtered" :title="$t('Перетащите чтобы изменить порядок')" style="cursor: grab" small icon color="secondary lighten-5" class="body-handle"><v-icon>mdi-swap-vertical</v-icon></v-btn>
            </div>
          </td>
        </tr>
      </template>

      <template #col:name="{ item }">
        <span :style="`${item.alt_name ? 'text-decoration: line-through' : ''}`">{{item.name}}</span><span v-if="item.alt_name"><br>{{item.alt_name}}</span>
      </template>

      <template #col:prices="{ item }">
        {{(item.prices.delivery + 0.0).toFixed(2)}}
      </template>

      <template #col:actions="{filtered, item}">
        <div class="hover-slave d-flex justify-end" style="z-index: 0">
          <v-btn :title="$t('Редактировать')" @click="edit(item)" small icon color="primary"><v-icon>mdi-pen</v-icon></v-btn>
          <v-btn v-if="!filtered" small icon color="primary" style="cursor: grab" :title="$t('Перетащите чтобы изменить порядок')" class="item-handle"><v-icon>mdi-swap-vertical</v-icon></v-btn>
        </div>
      </template>

    </TableBody>

    <v-bottom-sheet scrollable v-model="dish_editor">
      <DishEditor :item="editing_item" :original_value="original_editing_item" @close="dish_editor = false" />
    </v-bottom-sheet>
  </Table>
</template>

<script>
import Table from '../../common/CustomTable/Table.vue'
import TableHeader from '../../common/CustomTable/TableHeader.vue'
import TableBody from '../../common/CustomTable/TableBody.vue'
import DishEditor from './DishEditor.vue'
// import vuedraggable from 'vuedraggable'

export default {
  props: ['menu_categories', 'modifier_schemes_map', 'loading', 'menu_merged_items'],
  data: () => ({
    dish_editor: false,
    editing_item: {prices: {}},
    original_editing_item: {prices: {}},
    search: ''
  }),
  computed: {
    headers(){
      return [
        {
          text: '#',
          value: 'id',
          align: 'right'
        },
        {
          text: this.$t('Название'),
          value: 'name'
        },
        {
          text: this.$t('Путь по группам'),
          value: 'categ_path'
        },
        {
          text: this.$t('Стоимость'),
          align: 'right',
          value: 'prices'
        },
        {
          text: '',
          value: 'actions',
        },
      ]
    }
  },

  async mounted() {
    console.log('menu_categories', this.menu_categories)
    console.log('modifier_schemes_map', this.modifier_schemes_map)
    console.log('menu_merged_items', this.menu_merged_items)
  },

  methods: {
    edit(item) {
      this.editing_item = {...item}
      this.original_editing_item = {...item}
      this.dish_editor = true
    },
    async displaceMenuitem(move) {
      await this.$store.dispatch('displaceMenuitem', {from_id: move.from.id, to_id: move.to.id})
      this.$store.dispatch('throwTimeoutMessage', {
        message_data: this.$t('Изменения сохранены'),
        message_class: 'success'
      })
    },
    async displaceCategory(move){
      await this.$store.dispatch('displaceCategory', {from_id:  this.menu_categories[move.from].id, to_id: this.menu_categories[move.to].id})
      this.$store.dispatch('throwTimeoutMessage', {
        message_data: this.$t('Изменения сохранены'),
        message_class: 'success'
      })
    }
  },
  components: {
    Table,
    TableHeader,
    TableBody,
    DishEditor
    // vuedraggable,
  }
}
</script>

<style>
.hover-slave {
  opacity: 0;
  transition: all .1s ease-in-out;
}

.table tbody tr:hover .hover-slave {
  opacity: 1;
}
</style>